<template>
  <div class="animated fadeIn">
    <b-modal
      title="Choose period"
      class="modal-primary"
      v-model="modalDate"
      @ok="downloadCustom(), modalDate = false"
    >
      <b-form>
        <b-form-group label="From" label-for="date" :label-cols="3">
          <datepicker use-utc
            format="MM/dd/yyyy"
            :bootstrap-styling="true"
            v-model="dateFrom"
            name="dateFrom"
          ></datepicker>
        </b-form-group>
        <b-form-group label="To" label-for="dateTo" :label-cols="3">
          <datepicker use-utc format="MM/dd/yyyy" :bootstrap-styling="true" v-model="dateTo" name="dateTo"></datepicker>
        </b-form-group>
      </b-form>
    </b-modal>

    <b-row>
      <b-col lg="8" offset-lg="2">
        <b-card class="reports">
          <div slot="header">
            <h5 style="display: inline;" class="card-title mb-0">Download Reports</h5>
          </div>
          <b-row>
            <b-col lg="4" class="pb-2">
              <b-button
                class="download-button"
                variant="primary"
                size="lg"
                @click="download2019();"
              >
                <div style="display:inline-block;" v-if="loading2019" class="loading">
                  <b-row>
                    <b-col lg="12">
                      <div class="sk-double-bounce">
                        <div class="sk-child sk-double-bounce1"></div>
                        <div class="sk-child sk-double-bounce2"></div>
                      </div>
                    </b-col>
                  </b-row>
                </div>

                <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>
                Report For 2019
              </b-button>
            </b-col>
            <b-col lg="4" class="pb-2">
              <b-button
                class="download-button"
                variant="primary"
                size="lg"
                @click="download2020();"
              >
                <div style="display:inline-block;" v-if="loading2020" class="loading">
                  <b-row>
                    <b-col lg="12">
                      <div class="sk-double-bounce">
                        <div class="sk-child sk-double-bounce1"></div>
                        <div class="sk-child sk-double-bounce2"></div>
                      </div>
                    </b-col>
                  </b-row>
                </div>

                <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>
                Report For 2020
              </b-button>
            </b-col>
            <b-col lg="4" class="pb-2">
              <b-button
                class="download-button"
                variant="primary"
                size="lg"
                @click="modalDateEvent();"
              >
                <div style="display:inline-block;" v-if="loadingCustom" class="loading">
                  <b-row>
                    <b-col lg="12">
                      <div class="sk-double-bounce">
                        <div class="sk-child sk-double-bounce1"></div>
                        <div class="sk-child sk-double-bounce2"></div>
                      </div>
                    </b-col>
                  </b-row>
                </div>

                <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>
                Custom Report
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  name: "reports",
  components: { Datepicker },
  data() {
    return {
      locationsIds: "",
      loading2019: false,
      loading2020: false,
      loadingCustom: false,
      modalDate: false,
      dateFrom: "",
      dateTo: ""
    };
  },
  methods: {
    download2019() {
      this.loading2019 = true;
      let params = {};
      params = {
      };
      this.$http
        .get("api/reports/Portal_PBRS2019.php", {
          params,
          responseType: "blob"
        })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "SummaryReport_2019.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loading2019 = false;
          },
          err => {
            this.loading2019 = false;
            console.log(err);
          }
        );
    },
    download2020() {
      this.loading2020 = true;
      let params = {};
      params = {
      };

      this.$http
        .get("api/reports/Portal_PBRS2020.php", {
          params,
          responseType: "blob"
        })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "SummaryReport_2020.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loading2020 = false;
          },
          err => {
            this.loading2020 = false;
            console.log(err);
          }
        );
    },
    downloadCustom() {
      this.loadingCustom = true;
      let params = {};
      params = {
        date_from: this.dateFrom,
        date_to: this.dateTo
      };
      this.$http
        .get(
          "api/reports/Portal_PBRS_CustomPeriod.php",
          { params, responseType: "blob" }
        )
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "SummaryReport_Custom.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loadingCustom = false;
          },
          err => {
            this.loadingCustom = false;
            console.log(err);
          }
        );
    },
    modalDateEvent() {
      this.modalDate = true;
    }
  },
  mounted() {
    if (!localStorage.getItem("alpha_user")) {
      router.push("/pages/login/");
    }

    this.locationsIds = localStorage.getItem("locations");
  }
};
</script>

<style>
.download-button {
  display: block;
  margin: auto;
  font-weight: 600;
  padding: 0.6em;
}
.fa-file-excel-o {
  font-size: 1.4em;
  color: #ffffff68;
  transform: rotate(30deg);
  padding-right: 0.5em;
}
.sk-double-bounce {
  height: 20px !important;
  width: 20px !important;
  line-height: 55px;
  margin: auto;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
